import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref, watch } from 'vue'

interface Language {
  code: string
  label: string
  nativeLabel: string
  icon: string
}

interface Props {
  modelValue: boolean
  currentLanguage?: string
}

interface Emits {
  (e: 'update:modelValue', value: boolean): void
  (e: 'language-selected', code: string): void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CaptionLanguageDialog',
  props: {
    modelValue: { type: Boolean },
    currentLanguage: { default: 'en' }
  },
  emits: ["update:modelValue", "language-selected"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const model = ref(props.modelValue)
const selectedLanguage = ref(props.currentLanguage)

watch(() => props.modelValue, (v) => { model.value = v })
watch(model, (v) => { emit('update:modelValue', v) })
watch(() => props.currentLanguage, (v) => { selectedLanguage.value = v })

const languages: Language[] = [
  { code: 'en', label: 'English', nativeLabel: 'English', icon: 'mdi-translate' },
  { code: 'es', label: 'Spanish', nativeLabel: 'Español', icon: 'mdi-translate' },
  { code: 'de', label: 'German', nativeLabel: 'Deutsch', icon: 'mdi-translate' },
  { code: 'fr', label: 'French', nativeLabel: 'Français', icon: 'mdi-translate' },
  { code: 'pt', label: 'Portuguese', nativeLabel: 'Português', icon: 'mdi-translate' },
  { code: 'ru', label: 'Russian', nativeLabel: 'Русский', icon: 'mdi-translate' },
  { code: 'ja', label: 'Japanese', nativeLabel: '日本語', icon: 'mdi-translate' },
  { code: 'zh', label: 'Chinese (Simplified)', nativeLabel: '中文（简体）', icon: 'mdi-translate' },
  { code: 'ko', label: 'Korean', nativeLabel: '한국어', icon: 'mdi-translate' },
  { code: 'it', label: 'Italian', nativeLabel: 'Italiano', icon: 'mdi-translate' },
  { code: 'nl', label: 'Dutch', nativeLabel: 'Nederlands', icon: 'mdi-translate' },
  { code: 'ar', label: 'Arabic', nativeLabel: 'العربية', icon: 'mdi-translate' },
  { code: 'off', label: 'Turn off captions', nativeLabel: '', icon: 'mdi-closed-caption-off' },
]

function handleSelect(code: string) {
  selectedLanguage.value = code
}

function handleConfirm() {
  emit('language-selected', selectedLanguage.value)
  model.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_VBtnPrimary = _resolveComponent("VBtnPrimary")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: model.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((model).value = $event)),
    "max-width": "480"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { rounded: "lg" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "text-h6 pa-6 pb-4" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                start: "",
                color: "primary"
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("mdi-closed-caption-outline", -1)
                ]))]),
                _: 1
              }),
              _cache[3] || (_cache[3] = _createTextVNode(" Choose caption language ", -1))
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider),
          _createVNode(_component_v_card_text, { class: "pa-0" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list, { nav: "" }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(languages, (lang) => {
                    return _createVNode(_component_v_list_item, {
                      key: lang.code,
                      value: lang.code,
                      active: selectedLanguage.value === lang.code,
                      color: "primary",
                      rounded: "lg",
                      class: "mb-1",
                      onClick: ($event: any) => (handleSelect(lang.code))
                    }, {
                      prepend: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(lang.icon), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      append: _withCtx(() => [
                        (selectedLanguage.value === lang.code)
                          ? (_openBlock(), _createBlock(_component_v_icon, {
                              key: 0,
                              color: "primary"
                            }, {
                              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                _createTextVNode(" mdi-check ", -1)
                              ]))]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, { class: "text-body-1 font-weight-medium" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(lang.label), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_list_item_subtitle, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(lang.nativeLabel), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["value", "active", "onClick"])
                  }), 64))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider),
          _createVNode(_component_v_card_actions, { class: "pa-4" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                variant: "text",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (model.value = false))
              }, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createTextVNode("Cancel", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_VBtnPrimary, { onClick: handleConfirm }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                  _createTextVNode("Apply", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})